<template>
  <b-container fluid class="mt-4 p-0">
    <div class="custom-card d-flex align-items-center justify-content-center position-relative overflow-hidden">
      <div class="p-4 w-100">
        <div class="gold-bar mb-3"></div>

        <div class="mb-3">
          <div class="row-item d-flex align-items-center px-3 mb-2">
            <div class="dot gold mr-3"></div>
            <div class="line navy"></div>
          </div>

          <div class="row-item d-flex align-items-center px-3">
            <div class="dot muted mr-3"></div>
            <div class="line navy short"></div>
          </div>
        </div>
      </div>

      <div class="corner-accent"></div>
    </div>
  </b-container>
</template>

<script>
export default {
  name: "DigitalPlaceholder"
}
</script>

<style scoped>
.custom-card {
  height: 12rem; /* ~ h-48 */
  background-color: #ffffff;
  border: 1px solid #f1f1f1;
}

/* Dark mode support (optional) */
body.dark .custom-card {
  background-color: #0b1c2d;
  border-color: rgba(11, 28, 45, 0.5);
}

.gold-bar {
  height: 4px;
  width: 48px;
  background-color: #c9a24d;
}

.row-item {
  height: 40px;
  background-color: #f7f7f7;
}

body.dark .row-item {
  background-color: rgba(255, 255, 255, 0.05);
}

.dot {
  width: 8px;
  height: 8px;
}

.dot.gold {
  background-color: #c9a24d;
}

.dot.muted {
  background-color: rgba(11, 28, 45, 0.1);
}

body.dark .dot.muted {
  background-color: rgba(201, 162, 77, 0.1);
}

.line {
  height: 4px;
  width: 96px;
  background-color: rgba(11, 28, 45, 0.2);
}

.line.short {
  width: 64px;
}

body.dark .line {
  background-color: rgba(201, 162, 77, 0.2);
}

.corner-accent {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 64px;
  height: 64px;
  background-color: rgba(201, 162, 77, 0.05);
}
</style>
